import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=31c6dfcd&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c6dfcd')) {
      api.createRecord('31c6dfcd', component.options)
    } else {
      api.reload('31c6dfcd', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=31c6dfcd&", function () {
      api.rerender('31c6dfcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Chemicallist/Index.vue"
export default component.exports